import { Box } from '@mui/material'
import { useTranslations } from '~/src/hooks/useTranslations'
import { FormikProps } from 'formik'
import FormikTextField from '~/src/components/mui-wrappers/fields/FormikTextField'
import { LoginTypeSelectionFormInterface } from '~/src/types/forms/LoginTypeSelectionFormInterface'
import PhoneInput from '~/src/components/mui-wrappers/styled/phone-input'
import { useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import { useState } from 'react'
import { useEoValue } from '~/src/hooks/useEoState'
import { AUTHENTICATION_FLOW_STATE, AuthenticationFlowState } from '~/src/stores/authentication-flow'

interface Props {
  form: FormikProps<LoginTypeSelectionFormInterface>,
  fieldsColor: 'container' | 'content',
}

const LoginTypeSelectionFormFields = ({ form, fieldsColor = 'content' }: Props) => {
  const theme = useCustomMuiTheme()
  const { t } = useTranslations()
  const authenticationFlowState = useEoValue<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)
  const [ fieldFocused, setFieldFocused ] = useState<keyof LoginTypeSelectionFormInterface | null>(null)

  const _handleOnFocus = (name: keyof LoginTypeSelectionFormInterface) => {
    setFieldFocused(name)

    if ((name === 'email' && !form.values.email) || (name === 'phone' && !form.values.phone)) {
      void form.resetForm()
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        [theme.breakpoints.down('md')]: {
          gap: 1.5
        }
      }}
    >
      {authenticationFlowState.loginType === 'email' && (
        <FormikTextField
          TextFieldProps={{
            form,
            disabled: fieldFocused === 'phone',
            color: fieldsColor,
            name: 'email',
            inputMode: 'email',
            label: t('auth.emailAddress'),
            InputProps: {
              onFocus: () => _handleOnFocus('email'),
              onBlur: () => setFieldFocused(null),
              sx: {
                input: {
                  fontSize: '1.25rem'
                }
              }
            }
          }}
        />
      )}

      {authenticationFlowState.loginType === 'phone' && (
        <PhoneInput
          PhoneInputProps={{
            form,
            disabled: fieldFocused === 'email',
            label: t('auth.phone'),
            color: fieldsColor,
            name: 'phone',
            InputProps: {
              onFocus: () => _handleOnFocus('phone'),
              onBlur: () => setFieldFocused(null),
              sx: {
                input: {
                  fontSize: '1.25rem'
                }
              }
            }
          }}
        />
      )}
    </Box>
  )
}

export default LoginTypeSelectionFormFields
